/// <amd-module name="typeahead/features/SuggestAlternateRegionHSRP" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggestServiceParamModifier} from "typeahead/core/SuggestServiceParamModifier";

export class SuggestAlternateRegionHSRP extends SuggestServiceParamModifier {
    protected regionId: string = "";
    protected configuration: IStripingConfiguration[] = [
        {
            clients: ["Hotels.Search"],
            lobs: ["HOTELS"],
        },
    ];

    protected featureName: string;

    constructor() {
        super();
        TypeaheadMessage.subscribe(SubmitClickedMessage.getTopic(), (topic: string, message: SubmitClickedMessage) => {
            this.regionId = "";
        });
    }

    protected modify(params: ISuggestServiceQueryParams, context: IContext, options: any) {
        if (!options.srchText) {
            // use regionId which was loaded with page even if input changes.
            if (this.regionId === "") {
                this.regionId = $("#regionId").val();
            }
            params.rid = this.regionId;
        }
    }
}
